import { createComponent } from '@mtfe/sweet';
import { eventBus, common, createObserve } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';
import store from '../../store/index';
import { renderPoiInfoI } from '../../utils/renderPoi';
import { filterPoiInfoWidthSKu } from '../../utils/filter';
import http from '../../service';

const { storeCommon } = store;
const { createUniqueId } = common;

const SkuCouponListV3Ready = (containerId, poiInfoObjList) => {
    eventBus.$on('SkuCouponListV3Ready', () => {
        const { dom_sg_every_day_coupon: domSgEveryDayCoupon } = storeCommon.structInfo.struct;
        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];

        if (storeSgEveryDayCoupon.isShow) {
            const couponDomList = Array.from(document.querySelectorAll(`#${containerId} [coupon-monitor-index]`));
            const observerCb = async (err, item) => {
                if (err) {
                    return;
                }
                try {
                    const currentIndex = item.target.getAttribute('coupon-monitor-index');
                    const currentCouponList = storeSgEveryDayCoupon.discountData.couponList;
                    const url = `${currentCouponList[currentIndex].impMonitorUrl}`;
                    await http.gMonitorApi(url);
                } catch (error) {
                    console.error('曝光失败', error);
                }
            };
            if (couponDomList.length > 0) {
                createObserve(observerCb, couponDomList);
            }
            poiInfoObjList.forEach((poiInfoObj) => {
                poiInfoObj.ready();
            });
        }
    });
};

const SkuCouponListV3 = () => {
    try {
        const { dom_sg_every_day_coupon: domSgEveryDayCoupon } = storeCommon.structInfo.struct;

        const storeSgEveryDayCoupon = store[domSgEveryDayCoupon.recallBizId];

        if (
            !storeSgEveryDayCoupon ||
            !storeSgEveryDayCoupon.isShow ||
            !storeSgEveryDayCoupon.discountData ||
            !Array.isArray(storeSgEveryDayCoupon.discountData.couponList) ||
            !storeSgEveryDayCoupon.discountData.couponList.length > 0
        ) {
            return '';
        }
        const { couponList } = storeSgEveryDayCoupon.discountData;
        const containerId = createUniqueId();
        const poiInfoObjList = filterPoiInfoWidthSKu(couponList).map((poiInfo, index) => renderPoiInfoI(poiInfo, index, storeSgEveryDayCoupon.recallBizId));

        const data = {
            poiListDom: poiInfoObjList.map((poiInfoObj) => `<div class="mb16">${poiInfoObj.getComponent()}</div>`).join(''),
            containerId,
        };
        const events = {};
        SkuCouponListV3Ready(containerId, poiInfoObjList);
        const component = createComponent(tpl, { data, style }, events);
        return component;
    } catch (error) {
        console.error(error);
        return '';
    }
};

export default SkuCouponListV3;
